import * as types from './checkList.types';
import * as constants from './checkList.constants';
import { generateResourceReducer } from '../generators/resource.reducer';

export const checkListReducer = generateResourceReducer<types.ICheckList>({
  STORE: constants.STORE_CHECKLIST,
  CLEAR: constants.CLEAR_CHECKLIST,
});
